import React from "react";

const Namespace = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <g>
        <path
          d="M13.5 26Q16.0438 26 18.3652 25.0181Q20.6083 24.0694 22.3388 22.3388Q24.0694 20.6083 25.0181 18.3652Q26 16.0438 26 13.5Q26 10.9562 25.0181 8.63477Q24.0694 6.39173 22.3388 4.66116Q20.6083 2.93063 18.3652 1.9819Q16.0438 1 13.5 1Q10.9562 1 8.63477 1.9819Q6.39173 2.93063 4.66116 4.66117Q2.93063 6.39172 1.9819 8.63477Q1 10.9562 1 13.5Q1 16.0438 1.9819 18.3652Q2.93063 20.6083 4.66116 22.3388Q6.39173 24.0694 8.63477 25.0181Q10.9562 26 13.5 26ZM13.5 28Q10.5507 28 7.85566 26.8601Q5.25335 25.7594 3.24695 23.753Q1.24058 21.7466 0.139893 19.1443Q-1 16.4493 -1 13.5Q-1 10.5507 0.139893 7.85566Q1.24058 5.25335 3.24695 3.24694Q5.25335 1.24058 7.85566 0.139893Q10.5507 -1 13.5 -1Q16.4493 -1 19.1443 0.139893Q21.7466 1.24058 23.753 3.24695Q25.7594 5.25335 26.8601 7.85566Q28 10.5507 28 13.5Q28 16.4493 26.8601 19.1443Q25.7594 21.7466 23.753 23.753Q21.7466 25.7594 19.1443 26.8601Q16.4493 28 13.5 28Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 2 1)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M1.14583 0C1.77865 0 2.29167 0.513012 2.29167 1.14583C2.29167 1.77865 1.77865 2.29167 1.14583 2.29167C0.513013 2.29167 0 1.77865 0 1.14583C0 0.513012 0.513013 0 1.14583 0Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 14 9)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M-0.0833333 0.996577C-0.596624 0.95423 -1 0.524217 -1 0C-1 -0.55228 -0.55228 -1 0 -1L0.916667 -1Q1.01516 -1 1.11176 -0.980785Q1.20836 -0.96157 1.29935 -0.923879Q1.39034 -0.886188 1.47224 -0.83147Q1.55413 -0.776751 1.62377 -0.707107Q1.69342 -0.637463 1.74814 -0.55557Q1.80286 -0.473678 1.84055 -0.382683Q1.87824 -0.291689 1.89745 -0.19509Q1.91667 -0.0984914 1.91667 0L1.91667 6.41667C1.91667 6.96895 1.46895 7.41667 0.916667 7.41667C0.364387 7.41667 -0.0833333 6.96895 -0.0833333 6.41667L-0.0833333 0.996577Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 14.458 13.125)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default Namespace;
